<template>
  <div class="fixed-column-select">
    <v-data-table
      :items="data.filter(x => x.show === true)"
      :items-per-page="25"
      :headers="headers"
      sort-by="nom"
      :sort-desc="false"
      dense
      :mobile-breakpoint="0"
      show-select
      :value="selected"
      @input="v => $emit('update:selected', v)"
      hide-default-footer
      :page.sync="page"
      @page-count="pageCount = $event"
    >
      <template v-slot:item.nom="{ item }">
        <v-sheet width="250px">
          <v-text-field
            dense
            filled
            class="no-before"
            hide-details
            v-model="item.nom"
            @change="item.is_changed = true"
            :disabled="item.is_deleted"
          ></v-text-field>
        </v-sheet>
      </template>
      <template v-slot:item.recipe_key="{ item }">
        <v-sheet width="250px">
          <v-text-field
            dense
            filled
            class="no-before"
            hide-details
            v-model="item.data.recipe_key"
            @change="item.is_changed = true"
            :disabled="item.is_deleted"
          ></v-text-field>
        </v-sheet>
      </template>
      <template v-slot:item.tags="{ item }">
        <v-sheet width="700px">
          <v-text-field
            dense
            filled
            class="no-before"
            hide-details
            :value="item.data.tags.join(',')"
            @change="
              v => {
                item.data.tags = v.split(',');
                item.is_changed = true;
              }
            "
            :disabled="item.is_deleted"
          ></v-text-field>
        </v-sheet>
      </template>
      <template v-slot:footer>
        <v-pagination
          color="accent"
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "RecipeBulkEditorGrid",
  props: {
    data: {
      type: Array,
      required: true
    },
    selected: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      page: 0,
      pageCount: 1,
      headers: [
        { value: "nom", text: "Nom" },
        { value: "recipe_key", text: "Clé d'intégration" },
        { value: "tags", text: "# (séparé avec , )", sortable: false }
      ]
    };
  }
};
</script>

<style></style>
